export default "__VITE_ASSET__c0aee7df__"